/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  map of all rent reports
 */

import type { RentReportCityState } from '@zcode/state-type'

export const rentReports = {
  'atlanta-ga': 'https://www.zumperrentals.com/blog/atlanta-metro-report/',
  'austin-tx': 'https://www.zumperrentals.com/blog/austin-metro-report/',
  'boston-ma': 'https://www.zumperrentals.com/blog/boston-metro-report/',
  'charlotte-nc': 'https://www.zumperrentals.com/blog/charlotte-metro-report/',
  'chicago-il': 'https://www.zumperrentals.com/blog/chicago-metro-report/',
  'dallas-tx': 'https://www.zumperrentals.com/blog/dallas-metro-report/',
  'detroit-mi': 'https://www.zumperrentals.com/blog/detroit-metro-report/',
  'denver-co': 'https://www.zumperrentals.com/blog/denver-metro-report/',
  'houston-tx': 'https://www.zumperrentals.com/blog/houston-metro-report/',
  'kansas-city-mo': 'https://www.zumperrentals.com/blog/kansas-city-metro-report/',
  'las-vegas-nv': 'https://www.zumperrentals.com/blog/las-vegas-metro-report/',
  'los-angeles-ca': 'https://www.zumperrentals.com/blog/los-angeles-metro-report/',
  'miami-fl': 'https://www.zumperrentals.com/blog/miami-metro-report/',
  'minneapolis-mn': 'https://www.zumperrentals.com/blog/minneapolis-metro-report/',
  'nashville-tn': 'https://www.zumperrentals.com/blog/nashville-metro-report/',
  'new-york-ny': 'https://www.zumperrentals.com/blog/new-york-city-metro-report/',
  'norfolk-va': 'https://www.zumperrentals.com/blog/norfolk-metro-report/',
  'orlando-fl': 'https://www.zumperrentals.com/blog/orlando-metro-report/',
  'philadelphia-pa': 'https://www.zumperrentals.com/blog/philadelphia-metro-report/',
  'phoenix-az': 'https://www.zumperrentals.com/blog/phoenix-metro-report/',
  'portland-or': 'https://www.zumperrentals.com/blog/portland-metro-report/',
  'sacramento-ca': 'https://www.zumperrentals.com/blog/sacramento-metro-report/',
  'salt-lake-city-ut': 'https://www.zumperrentals.com/blog/salt-lake-city-metro-report/',
  'san-diego-ca': 'https://www.zumperrentals.com/blog/san-diego-metro-report/',
  'san-francisco-ca': 'https://www.zumperrentals.com/blog/san-francisco-bay-area-metro-report/',
  'seattle-wa': 'https://www.zumperrentals.com/blog/seattle-metro-report/',
  'tampa-fl': 'https://www.zumperrentals.com/blog/tampa-metro-report/',
  'washington-dc': 'https://www.zumperrentals.com/blog/washington-d-c-metro-report/',
} as const satisfies { [K in RentReportCityState]: string }

export function isRentReportCityState(cityState: string): cityState is RentReportCityState {
  return Object.hasOwn(rentReports, cityState)
}
